<template>
    <section class="infobox">
        <modal v-if="modalContent" @modal-onclose="modalContent=null" :img_url="modalContent" />

        <div class="info">
          <p class="info-caption">Статус:</p>
          <!-- <p class="info-value" :style="{'background-color': categories[p.kod_ststext].color}"> -->
          <p class="info-value">
            {{categories[p.kod_ststext].text}}
          </p>
        </div>

        <div class="info">
          <p class="info-caption">Розділ документації:</p>
          <p class="info-value">{{p.rozdildocum}}</p>
          <p class="info-caption">Код за схемою:</p>
          <p class="info-value">{{p.kodtszashem}}</p>
        </div>

        <div class="info"> 
          <p class="info-caption">Місце розташування:</p>
          <p class="info-value">{{p.misceroztash}}</p>
          <p class="info-caption">Площа, м<sup>2</sup></p>
          <p class="info-value">{{p.plosha}}</p>
        </div>

        <div class="info">
          <p class="info-caption">Архітип:</p>
          <p class="info-image-preview" v-if="p.url_architype_prewiu">
            <img :src="local_image(p.url_architype_prewiu)" @click="modalContent=local_image(p.url_architype_prewiu)"/>
          </p>
          <p class="info-value">{{p.arhityp}}</p>
        </div>

        <div class="info">
          <p class="info-caption">План:</p>
          <p class="info-image-preview" v-if="p.url_shema_prewiu">
            <img :src="local_image(p.url_shema_prewiu)" @click="modalContent=local_image(p.url_shema_prewiu)"/>
          </p>
        </div>
    </section>    
</template>

<script>
import Modal from '../Modal'
import * as d3 from 'd3'
const time_format =  d3.timeFormat("%Y-%m-%d")

export default {
    name: "info-box",
    components: {
      Modal,
    },
    props: {
        d: Object,
        categories: Object
    },

    data() {
      return {
        modalContent: null
      }
    },
    
    computed: {
      p() {
        return this.d.properties
      }
    },
    
    methods: {
      format_date(v) {
        return time_format(v);
      },

      local_image(url) {
        let filename = url.replace('https://slav.donmbk.gov.ua/back/downloadFile/4/?fileName=', '')
        return `./data/mafy_images/${filename}`
      }
    }
}
</script>

<style lang="scss" scoped>

.infobox {
  line-height: 1.3em;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-column-gap: 2em;
  grid-row-gap: 1em;

 .info {
    border-top: 1px solid black;
  }

  .info-caption {
    font-size: 0.7em;
    margin-bottom: 0.015em;
  }

  .info-value {
    margin-bottom: 1em;
  }

  .info-image-preview {
    margin-bottom: 0;
  }

  .info-image-preview img {
    max-width: 100%;
    cursor: pointer;
    &:hover {
      border: 2px solid rgb(64, 201, 148);
    }
    margin-bottom: 0em;
  }

  a {
    img {
      height: 1em;
      display: inline-block;
      vertical-align: baseline;
    }
  }
}
</style>>




